module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_7005.bbaa66cc.png";